import { logger } from '@belong/logging';
import { IInitiateChatResponseV2 } from '@belong/types/api/chat';

const SESSION_KEY_KEY = 'belong_chat_session_key';
export const clearSessionKey = (): void => {
  window.localStorage.removeItem(SESSION_KEY_KEY);
};

export const saveSessionKey = (initiateChatResponse: string): void => {
  const encodedSessionKey = window.btoa(initiateChatResponse);
  window.localStorage.setItem(SESSION_KEY_KEY, encodedSessionKey);
};

export const loadSessionKey = (): string | undefined => {
  return window.localStorage.getItem(SESSION_KEY_KEY) || undefined;
};

export const decodeSessionKey = (encodedSessionKey: string | undefined): IInitiateChatResponseV2 | void => {
  try {
    if (encodedSessionKey) {
      return JSON.parse(window.atob(encodedSessionKey));
    }
  } catch (e) {
    logger.error('Could not parse existing chat session key');
    clearSessionKey();
  }
};

export const replaceSessionKey = (contactId?: string): void => {
  if (!contactId) {
    logger.error('New chat session contactId is empty');
    return;
  }

  const existingKey = loadSessionKey();

  if (!existingKey) {
    // do nothing... make sure current chat is working first
    logger.error('Could not load existing chat session key, should exist');
    return;
  }

  try {
    const existingDetails = JSON.parse(window.atob(existingKey));

    // Only update contactId, other fields are for customer, keep the same
    const newBody = {
      data: {
        startChatResult: {
          ...existingDetails.data.startChatResult,
          contactId
        }
      }
    };

    // Save new session
    saveSessionKey(JSON.stringify(newBody));
  } catch (e) {
    logger.error('Updating chat session key failed', e);
  }
};

const WAS_OPEN_KEY = 'belong_chat_was_open';
export const saveWasOpen = (wasOpen: boolean | undefined): void => {
  window.localStorage.setItem(WAS_OPEN_KEY, JSON.stringify(wasOpen));
};

export const loadWasOpen = (): boolean => {
  return window.localStorage.getItem(WAS_OPEN_KEY) === 'true';
};

const WAS_CONNECTED_KEY = 'belong_chat_was_connected';
export const saveWasConnected = (wasConnected: boolean | undefined): void => {
  window.localStorage.setItem(WAS_CONNECTED_KEY, JSON.stringify(wasConnected));
};

export const loadWasConnected = (): boolean => {
  return window.localStorage.getItem(WAS_CONNECTED_KEY) === 'true';
};
